import { motion } from "framer-motion";

export const Section = ({ 
  children, 
  className = "", 
  id,
  background = "default",
  containerClass = "max-w-7xl mx-auto px-6 md:px-12"
}) => {
  const backgrounds = {
    default: "bg-obsidian",
    surface: "bg-surface",
    gradient: "bg-gradient-to-b from-obsidian to-charcoal",
    gaming: "relative bg-obsidian overflow-hidden",
  };

  return (
    <section 
      id={id}
      className={`py-24 md:py-32 ${backgrounds[background]} ${className}`}
    >
      {background === "gaming" && (
        <div className="absolute inset-0 bg-gaming-glow opacity-30 pointer-events-none" />
      )}
      <div className={`${containerClass} relative z-10`}>
        {children}
      </div>
    </section>
  );
};

export const SectionHeader = ({ 
  label, 
  title, 
  description,
  align = "center"
}) => {
  const alignClasses = {
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto",
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className={`max-w-3xl mb-16 ${alignClasses[align]}`}
    >
      {label && (
        <span className="inline-block px-4 py-1.5 text-xs font-medium text-gold-400 bg-gold-500/10 rounded-full mb-4 tracking-wider uppercase">
          {label}
        </span>
      )}
      <h2 className="font-heading text-4xl md:text-5xl text-white font-semibold tracking-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-6 text-gray-400 text-base md:text-lg leading-relaxed">
          {description}
        </p>
      )}
    </motion.div>
  );
};
